import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

// root state object.
// each Vuex instance is just a single state tree.
export default new Vuex.Store({
  state: {
    user: {
      loginTime: '',
      dispalyOptions: ''
    },
    app: {
      api: {
        protocol: 'https',
        path: '/webengine/webapi20.avfp',
        entry: 'func',
        type: 'get',
        domain: {
          'default': 'api.edexis.com'
        },
        request: {
          login: {
            type: 'post',
            task: 'log_login',
            option: {
              user: true,
              password: true
            }
          },
          logout: {
            task: 'log_logout'
          }
        }
      }
    }
  },

  // mutations are operations that actually mutates the state.
  // each mutation handler gets the entire state tree as the
  // first argument, followed by additional payload arguments.
  // mutations must be synchronous and can be recorded by plugins
  // for debugging purposes.
  mutations: {
    setRouteOptions (state, request) {
      for (var [name, options] of Object.entries(request)) {
        state.app.api.request[name].request = {}
        state.app.api.request[name].request.params = {}
        for (let key in state.app.api.request[name].option) {
          state.app.api.request[name].request.params[key] = options[key]
        }
      }
    },
    buildRequest (state, name) {
      console.log(name)
      let route = state.app.api.request[name]
      route.request.type = (route.type ? route.type : state.app.api.type)

      route.request.url = state.app.api.protocol + '://'
      route.request.url += state.app.api.domain.default
      route.request.url += state.app.api.path

      if (route.request.type === 'get') {
        // If the request is a GET we are going to extend the request URL
        route.request.queryString = ''
        route.request.url += '?' + state.app.api.entry + '=' + route.task
        for (var [key, value] of Object.entries(route.request.params)) {
          route.request.queryString += '&' + key + '=' + value
        }
        route.request.url += route.request.queryString
      } else {
        // If the request is a POST we are going to add "func" to the params
        route.request.params[state.app.api.entry] = route.task
      }
    },
    updateUser (state, user) {
      window.localStorage.setItem('user', user)
    }
  },

  // actions are functions that causes side effects and can involve
  // asynchronous operations.
  actions: {
    buildApiReqeust ({ commit, state, getters }, request) {
      for (var [name, options] of Object.entries(request)) {
        commit('setRouteOptions', {[name]: options})
        commit('buildRequest', name)
      }
      return state.app.api.request[name].request
    },
    updateUser ({ commit, state, getters }, user) {
      commit('updateUser', user)
    }
  },

  // getters are functions
  getters: {
    user: state => {
      return window.localStorage.getItem('user')
    }
  }
})



// WEBPACK FOOTER //
// ./src/components/store.js